<template>
    <div>
        <v-select label="name"
                  :options="options"
                  :multiple="multiple"
                  :taggable="taggable"
                  :disabled="disabled"
                  v-model="selectedValue"
                  @input="$emit('input', selectedValue)"
                  @search="fetchData">
            <template slot="no-options">
                <div class="py-1 mt-1 px-6">
                    {{ placeHolder }}
                </div>
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center" v-html="parseData(option)"></div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="d-center" v-html="parseData(option)"></div>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        value: [Object, Array, String],
        optionsList: Array,
        endpoint: String,
        customOption: Function,
        autoLoad: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        taggable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeHolder: {
            type: String,
            default: 'Procurar...'
        }
    },
    watch: {
        value: function(val) {
            this.selectedValue = val;
        },
        optionsList(){
            this.options = this.optionsList
        }
    },
    data() {
        return {
            selectedValue: this.value || 'Selecione uma opção',
            options: this.optionsList || []
        }
    },
    created() {
        if(!this.endpoint || !this.autoLoad) {
            return;
        }
        fetch(
            `/json/${this.endpoint}`
        ).then(res => {
            res.json().then(json => (this.options = json.data || json.list));
        });
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        parseData(option) {
            if (!option.name) {
                return;
            }
            if ({}.toString.call(this.customOption) === '[object Function]') {
                return this.customOption(option);
            }
            return option.name;
        },
        search: _.debounce((loading, endpoint, search, vm) => {
            fetch(
                `/json/${endpoint}?q=${escape(search)}`
            ).then(res => {
                res.json().then(json => (vm.options = json.data || json.list));
                loading(false);
            });
        }, 850),
        fetchData(search, loading) {
            if (this.optionsList) {
                return;
            }
            loading(true);
            this.search(loading, this.endpoint, search, this);
        },
    }
}
</script>
